import { useContext, useState } from "react";
import styles from "../BundleBuilder.module.css";
import { Button, Divider } from "@shopify/polaris";
import { BundleBuilderContext, BundleBuilderContextType } from "../BundleBuilder";
import DesignTabsWrapper from "../../../../components/DesignTabsWrapper/DesignTabsWrapper";
import { CombinedBundleConfigInterface } from "../../Types";
import DesignProductCard from "./DesignProductCard";
import DesignReviewPage from "./DesignReviewPage";
import DesignStepsPage from "./DesignStepsPage";
import { useFormContext } from "react-hook-form";

const BundleBuilderDesignForm = () => {
    const { handleNext, inspectorTarget } = useContext(BundleBuilderContext) as BundleBuilderContextType;
    const [activeDesignTab, setActiveDesignTab] = useState(0);
    const { getValues } = useFormContext();

    const bundleConfig = getValues() as any as CombinedBundleConfigInterface;

    return (
        <div className={styles.formWrapper}>
            <div style={{ marginBottom: 10 }}>
                <Divider borderColor="border" />
            </div>
            <DesignTabsWrapper
                bundleConfig={bundleConfig}
                activeDesignTab={activeDesignTab}
                setActiveDesignTab={setActiveDesignTab}
                isReviewStepEnabled={!!(bundleConfig as any)?.review_step?.is_enabled}
                validate={async () => []}
                submit={() => {}}
                inspectorTarget={inspectorTarget}
            >
                {activeDesignTab == 0 && <DesignProductCard />}
                {activeDesignTab == 1 && <DesignStepsPage />}
                {activeDesignTab == 2 && <DesignReviewPage />}
            </DesignTabsWrapper>

            {handleNext && (
                <>
                    <div className={styles.dividerStyle}>
                        <Divider borderColor="border" />
                    </div>
                    <div className={styles.bottomRowCta}>
                        <Button onClick={() => handleNext(0, "Content")}>Back</Button>
                        <Button onClick={() => handleNext(2, "Target")}>Next</Button>
                    </div>
                </>
            )}
        </div>
    );
};

export default BundleBuilderDesignForm;
